var defaultEncoding
/* istanbul ignore next */
if (process.browser) {
  defaultEncoding = 'utf-8'
} else {
  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10)

  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary'
}
module.exports = defaultEncoding



//////////////////
// WEBPACK FOOTER
// ./~/pbkdf2/lib/default-encoding.js
// module id = 359
// module chunks = 0 1